import React, { Component } from 'react'
import { compose} from 'recompose'
import { Link } from 'react-router-dom'
import { auth } from '../../../firebase'
import { withStyles } from '@material-ui/core'
import Card from '@material-ui/core/Card'
import Button from '@material-ui/core/Button'
import Input from '@material-ui/core/Input'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  card: {
  // maxWidth: 320,
    marginBottom: theme.spacing.unit,
    padding: theme.spacing.unit,
  
    border: '2px solid' +theme.palette.primary.light
  },
  input: {
    marginTop: theme.spacing.unit
  },
  lable: {
    fontSize: '0.7422em',
    fontWeight: 'bold'
},
button: {
  marginTop: theme.spacing.unit
}
})


const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  email: '',
  error: null,
};

class PasswordForgetPage extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    const { email } = this.state;

    auth.doPasswordReset(email)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });

    event.preventDefault();
  }

  renderInput = ()=> {
    const {classes} = this.props
    return (
      <Input
          placeholder="Email Adresse"
          className={classes.input}
          onChange={event => this.setState(byPropKey('email', event.target.value))}
          inputProps={{
            'aria-label': 'Description',
          }}
      />
    )
  }
  render() {
    const {
      email,
      error,
    } = this.state;

    const isInvalid = email === '';
    const {classes} = this.props
    return (
      <Card className={classes.card}>
         <Typography className={classes.lable} variant='button'>Kennwort Reset Link zusenden</Typography>
        <form onSubmit={this.onSubmit}>
          {this.renderInput(isInvalid)}
          <Button 
            disabled={isInvalid}
            variant="contained"
            color="primary"
            className={classes.button}
            type="submit">
            Link senden
          </Button>

          { error && <p>{error.message}</p> }
        </form>
      </Card>
    );
  }
}

const PasswordForgetLink = () =>
  <p>
    <Link to="/passwordForget">Passwort vergessen?</Link>
  </p>

export default compose (
  withStyles(styles))(PasswordForgetPage)

export {
  PasswordForgetLink,
}


// WEBPACK FOOTER //
// ./src/Components/UserAuth/UserAccount/PasswordForget.js